import { object } from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import BetConfigDialog from 'atg/components/dialog/BetConfigDialog';
import CouponsDialog from 'atg/components/dialog/CouponsDialog';
import TemplateDialog from 'atg/components/dialog/TemplateDialog';
import * as DialogTypes from 'shared/constants/DialogTypes';
import ShareDialogContainer from 'shared/containers/ShareDialogContainer';
import { dialogs } from 'shared/redux/selectors';
import { createPortal } from 'shared/utils/dialogUtils';

import ArchiveDialogContainer from './ArchiveDialogContainer';
import JokerWizDialogContainer from './JokerWizDialogContainer';
import ReportDialogContainer from './ReportDialogContainer';

const mapStateToProps = state => ({
  dialogs: dialogs.getDialogs(state),
});

export default connect(mapStateToProps)(
  class Dialogs extends Component {
    static propTypes = {
      jokerController: object.isRequired,
    };

    render() {
      const { dialogs, jokerController } = this.props;

      return dialogs.map(({ type, key, props }) => {
        switch (type) {
          case DialogTypes.ATG_ARCHIVE: {
            const archiveProps = {
              ...props,
              onOpenBetClick: jokerController.openArchivedBet,
              onDuplicateBetClick: jokerController.duplicateArchivedBet,
            };
            return createPortal(
              ArchiveDialogContainer,
              archiveProps,
              key,
              'archive',
            );
          }
          case DialogTypes.ATG_REPORT:
            return createPortal(
              ReportDialogContainer,
              props,
              key,
              'html-export',
            );
          case DialogTypes.ATG_SHARE:
            return createPortal(
              ShareDialogContainer,
              props,
              key,
              'html-export',
            );
          case DialogTypes.ATG_COUPONS:
            return createPortal(CouponsDialog, props, key, 'coupons');
          case DialogTypes.ATG_TEMPLATE:
            return createPortal(TemplateDialog, props, key, 'bet-template');
          case DialogTypes.ATG_BET_CONFIG:
            return createPortal(BetConfigDialog, props, key, 'bet-config');
          case DialogTypes.JOKERWIZ_DIALOG:
            return createPortal(
              JokerWizDialogContainer,
              props,
              key,
              'jokerwiz',
            );
          default:
            return null;
        }
      });
    }
  },
);
